var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "934.000000pt",
    height: "534.000000pt",
    viewBox: "0 0 934.000000 534.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,534.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4389 5191 c-37 -15 -488 -290 -714 -436 -27 -18 -324 -204 -660 -413 -353 -220 -629 -399 -654 -424 -66 -65 -96 -136 -96 -228 0 -63 5 -86 29 -135 34 -68 72 -108 331 -347 259 -238 468 -431 603 -557 62 -57 121 -112 131 -120 10 -9 69 -63 131 -121 62 -58 124 -116 139 -129 14 -13 51 -47 81 -75 50 -46 253 -234 340 -314 39 -36 124 -82 152 -82 11 0 30 11 43 25 46 45 38 105 -85 608 -60 249 -112 472 -116 496 l-7 44 204 -6 c761 -24 1326 -225 1617 -574 222 -266 292 -596 192 -904 -140 -429 -600 -852 -1314 -1210 -70 -35 -142 -77 -159 -92 -28 -26 -29 -29 -13 -45 26 -26 148 -20 361 17 638 112 1127 302 1490 579 535 409 760 1023 624 1697 -61 305 -191 562 -397 784 -436 473 -1299 839 -2336 990 -76 11 -140 22 -142 24 -7 7 67 177 196 452 73 154 141 305 152 335 54 148 5 211 -123 161z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.b8a77cf7.svg";
export { ForwardRef as ReactComponent };